import * as React from 'react';

import {Checkbox} from 'shells/checkbox/checkbox';
import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {UpgradeArrowIcon} from 'shells/icon/svg/upgrade-arrow-icon';

import {AiSummaryFeatureGateModal} from '../../../limits/feature-gates/ai-summary-feature-gate-modal';

export function SummarizeCheckboxUpsell() {
    const [showFeatureGate, setShowFeatureGate] = React.useState(false);

    return (
        <>
            <div className='mt-16' onClick={() => setShowFeatureGate(true)}>
                <Checkbox
                    label={
                        <div className='flex align-center pointer-cursor'>
                            Automatically summarize this call ✨{' '}
                            <button type='button'>
                                <UpgradeArrowIcon size={16} color={colors.blue} />
                            </button>
                        </div>
                    }
                    checked={false}
                    disabled={true}
                />
            </div>
            {showFeatureGate && (
                <AiSummaryFeatureGateModal
                    isOpen={showFeatureGate}
                    // @ts-expect-error
                    onClose={(e) => {
                        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                        e && e.stopPropagation();
                        setShowFeatureGate(false);
                    }}
                />
            )}
        </>
    );
}
